import { createElement } from '@max/max';
import View from '@hfe/max-view';
import { _remStyle } from '../../utils/style';
import LoadingView from '@max/leez-loading-view';
const isWeb = true;
const isMRN = false;
const Loading = (props) => {
    const { loadingBgColorType } = props;
    const style = _remStyle({
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        paddingTop: 30,
        paddingBottom: 30
    });
    return <View style={style}>
      <LoadingView bgColorType={loadingBgColorType} level={'medium'}/>
    </View>;
};
export default Loading;
